import { getI18n } from 'react-i18next';

export const CANNOT_SEND_2FA_RESET_REQUEST= 'CANNOT_SEND_2FA_RESET_REQUEST';
export const INVALID_2FA_RESET_REQUEST = 'validation.reset2FA.requestInvalid';
export const VALIDATION_NEW_2FA_TOKEN_INVALID = 'validation.new2FASecret.tokenInvalid';
export const VALIDATION_NEW_2FA_UNEXPECTED = 'validation.new2FASecret.unexpected';
export const VALIDATION_CONFIRMATION_TOTP_INVALID = 'validation.new2FASecret.totpInvalid';

export const create2FAErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    switch (code) {
        case VALIDATION_NEW_2FA_TOKEN_INVALID:
            return getI18n().t('request-2fa-reset.error.token-invalid', params);
        case VALIDATION_NEW_2FA_UNEXPECTED:
            return getI18n().t('request-2fa-reset.error.unexpected', params);
        case INVALID_2FA_RESET_REQUEST:
            return getI18n().t('request-2fa-reset.error.invalid', params);
        case CANNOT_SEND_2FA_RESET_REQUEST:
            return getI18n().t('request-2fa-reset.error.cannot-send');
        default:
            return undefined;
    }
};
